import { Shapes } from './lib/Shapes';

export const s = new Shapes();

export * from './lib/Result';
export * from './lib/configs';
export * from './lib/errors/BaseError';
export * from './lib/errors/CombinedError';
export * from './lib/errors/CombinedPropertyError';
export * from './lib/errors/ExpectedConstraintError';
export * from './lib/errors/ExpectedValidationError';
export * from './lib/errors/MissingPropertyError';
export * from './lib/errors/MultiplePossibilitiesConstraintError';
export * from './lib/errors/UnknownEnumValueError';
export * from './lib/errors/UnknownPropertyError';
export * from './lib/errors/ValidationError';
export * from './type-exports';
